import React from "react";
import "../App.css";
import { Pagination } from "./Pagination";

export function Footer({
  pageCount,
  pageNumber,
  onPageChange,
}) {
  if ((Number(pageCount) || 0) <= 1) {
    return null;
  }

  return (
    <div className="footer">
      <Pagination
        pageCount={pageCount}
        pageNumber={pageNumber}
        onPageChange={onPageChange}
      />
    </div>
  );
}
